var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalisando(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 555 541",
    style: {
      enableBackground: "new 0 0 555 541"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#474747;}\r\n\t.st1{fill:#343434;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#263238;}\r\n\t.st4{fill:#37474F;}\r\n\t.st5{fill:#455A64;}\r\n\t.st6{fill:#5757FF;}\r\n\t.st7{opacity:0.2;enable-background:new    ;}\r\n\t.st8{opacity:0.3;enable-background:new    ;}\r\n\t.st9{fill:#FAFAFA;}\r\n\t.st10{fill:#E0E0E0;}\r\n\t.st11{fill:#F0F0F0;}\r\n\t.st12{opacity:0.4;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{opacity:0.15;enable-background:new    ;}\r\n\t.st15{fill:#F5F5F5;}\r\n\t.st16{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st17{opacity:0.4;enable-background:new    ;}\r\n\t.st18{opacity:0.5;enable-background:new    ;}\r\n\t.st19{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st20{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st21{opacity:0.1;enable-background:new    ;}\r\n\t.st22{opacity:0.88;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st23{opacity:0.75;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st24{opacity:0.55;enable-background:new    ;}\r\n\t.st25{fill:#FFA8A7;}\r\n\t.st26{opacity:0.3;}\r\n\t.st27{fill:#F28F8F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spreadsheets-amico",
    transform: "translate(-8.41 -30.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-90-2",
    className: "st0",
    cx: 285.9,
    cy: 386.9,
    rx: 240.6,
    ry: 138.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-90",
    className: "st1",
    cx: 417.7,
    cy: 448.4,
    rx: 48.2,
    ry: 27.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-90-2",
    className: "st1",
    d: "M104.3,436l-39.5-22.8c-2.2-1.3-2.2-3.4,0-4.7l229.9-132.8 c2.5-1.3,5.5-1.3,8.1,0l39.5,22.8c2.2,1.3,2.2,3.4,0,4.7L112.4,436C109.9,437.3,106.9,437.3,104.3,436z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-90",
    className: "st2",
    d: "M130.9,98.4l-8.9,5.2c0-0.4,0.1-0.8,0.1-1.2v-2.6c0-4.6-3.2-6.5-7.2-4.2 c-1.7,1.1-3.2,2.5-4.3,4.1c-0.7-5.8-5.2-8-10.7-4.8c-6,3.5-10.8,11.8-10.8,18.7v3.9c0,1.5,0.3,3.1,0.9,4.5l-7.4,4.3 c-2.4,1.5-3.8,4.1-4,6.9c0,2.6,1.8,3.6,4,2.3l48.4-28c2.4-1.5,3.8-4.1,4-6.9C134.9,98.1,133.1,97.1,130.9,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-90-2",
    className: "st2",
    d: "M177.2,119.8l-6.8,3.9c0-0.3,0.1-0.6,0.1-0.9v-2c0-3.5-2.4-4.9-5.4-3.2 c-1.3,0.8-2.4,1.9-3.2,3.1c-0.5-4.4-3.9-6-8.1-3.6c-4.5,2.6-8.2,8.9-8.2,14.1v2.9c0,1.2,0.2,2.3,0.7,3.4l-5.6,3.2 c-1.8,1.2-2.9,3.1-3,5.2c0,1.9,1.4,2.7,3,1.8l36.6-21.1c1.8-1.2,2.9-3.1,3-5.2C180.2,119.6,178.9,118.8,177.2,119.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_701",
    className: "st3",
    d: "M246.4,395.3l34-19.6c3.5-2,5.3-4.7,5.3-7.3v-4.7l-35.3-19.9c-2-1.3-3.3-3.5-3.4-5.9v-41.9 l-59.4,34.3v41.9c0.1,2.4,1.4,4.6,3.4,5.9l30,17.3C228.1,399.3,239.4,399.3,246.4,395.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_702",
    d: "M201.9,379.6v4.7L191,378c-2-1.3-3.2-3.5-3.4-5.9v-41.9l11.3-6.5c0.2,2.9,0.5,5.8,0.7,8.7l-7.9,4.6 v32.7c0.1,2.4,1.4,4.6,3.4,5.9L201.9,379.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_703",
    className: "st4",
    d: "M191.8,369.8c0.1,2.4,1.4,4.6,3.4,5.9l25.9,14.9c7,4,18.4,4,25.4,0l34-19.6 c7-4,7-10.6,0-14.6l-25.9-14.9c-2-1.3-3.3-3.5-3.4-5.9v-32.7l-59.4,34.3L191.8,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_704",
    className: "st3",
    d: "M261.4,345.3L261.4,345.3l-6.9-4c-2-1.3-3.3-3.5-3.4-5.9v-32.7l-59.4,34.3v32.7 c0.1,2.4,1.4,4.6,3.4,5.9l6.8,3.9L261.4,345.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_705",
    className: "st5",
    d: "M285.7,363.6v4.7c0,2.6-1.8,5.3-5.3,7.3l-34,19.6c-3.7,2-7.9,3-12.1,3v-4.7 c4.2,0,8.4-1,12.1-3l34-19.7C283.9,368.9,285.7,366.3,285.7,363.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_706",
    className: "st5",
    d: "M96.5,410.5c2.6,1.3,5.6,1.2,8.2-0.1l229.6-132.5c2.5-1.6,4.1-4.3,4.2-7.3V84.2 c-0.1-2.9-1.6-5.6-4-7.2c-2.6-1.3-5.6-1.2-8.2,0.2L96.7,209.6c-2.5,1.6-4.1,4.3-4.2,7.3v186.4C92.6,406.2,94.1,408.9,96.5,410.5 L96.5,410.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_707",
    className: "st6",
    d: "M104.7,410.3l229.6-132.5c2.5-1.6,4.1-4.3,4.2-7.3V84.2c0-2.7-1.9-3.8-4.2-2.4L104.7,214.3 c-2.5,1.6-4.1,4.3-4.2,7.3v186.3C100.4,410.6,102.3,411.6,104.7,410.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_708",
    className: "st4",
    d: "M104.7,410.3l229.6-132.5c2.5-1.6,4.1-4.3,4.2-7.3V84.2c0-2.7-1.9-3.8-4.2-2.4L104.7,214.3 c-2.5,1.6-4.1,4.3-4.2,7.3v186.3C100.4,410.6,102.3,411.6,104.7,410.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_709",
    className: "st3",
    d: "M104,415.2c-2.4,1-5.2,1-7.6-0.2c-2.4-1.6-3.9-4.3-4-7.2v-16.9l7.9,4.6v16.9 C100.4,414.9,102,416,104,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_710",
    className: "st4",
    d: "M100.4,395.5v16.9c0,2.7,1.9,3.8,4.2,2.4l229.6-132.5c2.5-1.6,4.1-4.4,4.2-7.3V258 L100.4,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_711",
    className: "st7",
    d: "M100.4,395.5v16.9c0,2.7,1.9,3.8,4.2,2.4l229.6-132.5c2.5-1.6,4.1-4.4,4.2-7.3V258 L100.4,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_712",
    className: "st6",
    d: "M108.4,374.3V224.2c0.1-1.8,1-3.4,2.5-4.4L328,94.5c1.4-0.8,2.5-0.2,2.5,1.5V246 c-0.1,1.8-1,3.4-2.5,4.4L110.9,375.7C109.5,376.6,108.4,375.9,108.4,374.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    className: "st8",
    d: "M108.4,374.3V224.2c0.1-1.8,1-3.4,2.5-4.4L328,94.5c1.4-0.8,2.5-0.2,2.5,1.5V246 c-0.1,1.8-1,3.4-2.5,4.4L110.9,375.7C109.5,376.6,108.4,375.9,108.4,374.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    className: "st5",
    d: "M219.4,332.1c-2.4,1.5-3.8,4.1-4,6.9c0,2.5,1.8,3.6,4,2.3c2.4-1.5,3.8-4.1,4-6.9 C223.4,331.9,221.6,330.9,219.4,332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    className: "st3",
    d: "M101.7,217.4c-0.8,1.3-1.2,2.7-1.2,4.2v173.9l-7.9-4.6V217c0.1-1.5,0.5-2.9,1.2-4.2 L101.7,217.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-90-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    className: "st6",
    d: "M370.4,83.3c-0.7-0.4-1.5-0.3-2.2,0.2L139.5,215.6c-1.8,1.1-2.9,3-3,5.1V375 c-0.1,1,0.4,2,1.2,2.6c0.5,0.3,3,1.7,3.8,2.1c0.5,0.3,1.2,0.2,1.7-0.1L372,247.4c1.8-1.1,2.9-3,3-5.1v-155 c0.1-0.8-0.3-1.6-0.9-2C372.8,84.7,371.6,84,370.4,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    className: "st9",
    d: "M143.2,217.7L372,85.6c1.6-0.9,3-0.2,3,1.7v155c-0.1,2.1-1.2,4-3,5.1L143.2,379.6 c-1.6,0.9-3-0.6-3-2.5V222.9C140.4,220.8,141.5,218.9,143.2,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    className: "st10",
    d: "M373.4,86.2L373.4,86.2c0.5,0,0.6,0.7,0.6,1.1v155c-0.1,1.7-1,3.3-2.5,4.3L142.8,378.7 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.5,0-1-0.8-1-1.8V222.9c0.1-1.7,1-3.3,2.5-4.3L372.5,86.5C372.8,86.3,373.1,86.2,373.4,86.2  M373.4,85.2c-0.5,0-0.9,0.2-1.3,0.4L143.2,217.7c-1.8,1.1-2.9,3-3,5.1v154.2c0,1.5,0.8,2.8,2,2.8c0.4,0,0.7-0.1,1-0.3 L372,247.4c1.8-1.1,2.9-3,3-5.1v-155C375,85.9,374.4,85.2,373.4,85.2L373.4,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    className: "st11",
    d: "M137.7,377.5c0.3,0.2,2.6,1.5,3.6,2.1c-0.7-0.6-1.1-1.5-1.1-2.5V232.6l-3.8-2.2V375 C136.4,376,136.9,377,137.7,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    className: "st6",
    d: "M375,87.3c0-1.9-1.3-2.6-3-1.7L143.2,217.7c-1.8,1.1-2.9,3-3,5.1v9.7L375,97V87.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    className: "st13",
    d: "M372,85.6L143.2,217.7c-0.9,0.5-1.6,1.3-2.1,2.2l-3.8-2.2c0.5-0.9,1.2-1.6,2.1-2.2 L368.3,83.5c0.6-0.5,1.5-0.5,2.1-0.2c0.5,0.3,3,1.7,3.6,2.1C373.3,85.1,372.6,85.2,372,85.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    className: "st14",
    d: "M136.5,230.3v-9.6c0-1.1,0.4-2.1,0.9-3l3.8,2.2c-0.5,0.9-0.8,1.9-0.9,2.9v9.7 L136.5,230.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    className: "st2",
    d: "M140.3,232.6l0,17.5L375,114.5V97L140.3,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_724",
    className: "st10",
    d: "M150.1,231.3l15.2-8.7v8.7l-15.2,8.8L150.1,231.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    className: "st10",
    d: "M169,220.3v3.4l7.6-4.4V216L169,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    className: "st10",
    d: "M169,225.6v3.4l7.6-4.4v-3.4L169,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    className: "st10",
    d: "M180.4,213.8v3.4l7.6-4.4v-3.4L180.4,213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    className: "st10",
    d: "M180.4,219.1v3.4l7.6-4.4v-3.4L180.4,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    className: "st10",
    d: "M191.7,207.2v3.4l7.6-4.4v-3.4L191.7,207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    className: "st10",
    d: "M191.7,212.5v3.4l7.6-4.4v-3.4L191.7,212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    className: "st10",
    d: "M225.8,187.5v3.4l7.6-4.4v-3.4L225.8,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    className: "st10",
    d: "M225.8,192.9v3.4l7.6-4.4v-3.4L225.8,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    className: "st10",
    d: "M237.1,181v3.4l7.6-4.4v-3.4L237.1,181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    className: "st10",
    d: "M237.1,186.3v3.4l7.6-4.4v-3.4L237.1,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    className: "st10",
    d: "M248.5,174.4l0,3.4l7.6-4.4v-3.4L248.5,174.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    className: "st10",
    d: "M248.5,179.7l0,3.4l7.6-4.4v-3.4L248.5,179.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_737",
    className: "st10",
    d: "M203.1,200.7l18.9-10.9v8.7l-18.9,10.9V200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_738",
    className: "st10",
    d: "M259.9,167.9l15.2-8.7v8.7l-15.2,8.8L259.9,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    className: "st10",
    d: "M278.8,156.9l0,3.4l7.6-4.4v-3.4L278.8,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_740",
    className: "st10",
    d: "M278.8,162.3l0,3.4l7.6-4.4v-3.4L278.8,162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_741",
    className: "st10",
    d: "M290.1,150.4v3.4l7.6-4.4V146L290.1,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_742",
    className: "st10",
    d: "M290.1,155.7v3.4l7.6-4.4v-3.4L290.1,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_743",
    className: "st10",
    d: "M301.5,143.8v3.4l7.6-4.4v-3.4L301.5,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_744",
    className: "st10",
    d: "M301.5,149.1v3.4l7.6-4.4v-3.4L301.5,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    className: "st10",
    d: "M335.6,124.2v3.4l7.6-4.4v-3.4L335.6,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_746",
    className: "st10",
    d: "M335.6,129.5v3.4l7.6-4.4v-3.4L335.6,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_747",
    className: "st10",
    d: "M346.9,117.6v3.4l7.6-4.4v-3.4L346.9,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    className: "st10",
    d: "M346.9,122.9v3.4l7.6-4.4v-3.4L346.9,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    className: "st10",
    d: "M358.3,111v3.4l7.6-4.4v-3.4L358.3,111z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_750",
    className: "st10",
    d: "M358.3,116.4v3.4l7.6-4.4V112L358.3,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_751",
    className: "st10",
    d: "M312.9,137.3l18.9-10.9v8.7L312.9,146L312.9,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_752",
    className: "st10",
    d: "M140.3,232.6l-3.8-2.2v17.5l3.8,2.2L140.3,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_753",
    className: "st15",
    d: "M314.4,125.1v0.7c0,1,0.7,1.4,1.6,0.9l46-26.6c1-0.6,1.5-1.7,1.6-2.8v-0.6 c0-1-0.7-1.5-1.6-0.9l-46,26.5C315.1,122.9,314.5,124,314.4,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_754",
    className: "st5",
    d: "M363.6,97.3v-0.6c0-1-0.7-1.4-1.6-0.9l-6,3.4l0,0v4.4l0,0l6-3.4 C363,99.5,363.6,98.5,363.6,97.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--spreadsheets--inject-90-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    className: "st11",
    d: "M144.1,252.2l227.1-131.1v8.7L163,250v113.7l-18.9,10.9V252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_756",
    className: "st6",
    d: "M163,250l18.9-10.9v8.7L163,258.8V250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_757",
    className: "st6",
    d: "M163,319.9l18.9-10.9v8.7L163,328.7V319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_758",
    className: "st6",
    d: "M163,328.7l18.9-10.9v8.7L163,337.4V328.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_759",
    className: "st16",
    d: "M163,328.7l18.9-10.9v8.7L163,337.4V328.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_760",
    className: "st6",
    d: "M276.6,254.4l18.9-10.9v8.7l-18.9,10.9V254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_761",
    className: "st8",
    d: "M276.6,254.4l18.9-10.9v8.7l-18.9,10.9V254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_762",
    className: "st6",
    d: "M276.6,263.1l18.9-10.9v8.7l-18.9,10.9V263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_763",
    className: "st17",
    d: "M276.6,263.1l18.9-10.9v8.7l-18.9,10.9V263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_764",
    className: "st6",
    d: "M276.6,271.9l18.9-10.9v8.7l-18.9,10.9V271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_765",
    className: "st18",
    d: "M276.6,271.9l18.9-10.9v8.7l-18.9,10.9V271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_766",
    className: "st6",
    d: "M276.6,280.6l18.9-10.9v8.7l-18.9,10.9V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_767",
    className: "st8",
    d: "M276.6,280.6l18.9-10.9v8.7l-18.9,10.9V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_768",
    className: "st6",
    d: "M257.6,195.4l18.9-10.9v43.7l-18.9,10.9V195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_769",
    className: "st6",
    d: "M257.6,247.8l18.9-10.9v61.2L257.6,309V247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_770",
    className: "st6",
    d: "M181.9,291.5l18.9-10.9v8.7l-18.9,10.9V291.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_771",
    className: "st8",
    d: "M181.9,291.5l18.9-10.9v8.7l-18.9,10.9V291.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_772",
    className: "st6",
    d: "M219.8,226l18.9-10.9v8.7l-18.9,10.9V226z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_773",
    className: "st19",
    d: "M219.8,226l18.9-10.9v8.7l-18.9,10.9V226z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_774",
    className: "st6",
    d: "M314.4,223.8l18.9-10.9v8.7l-18.9,10.9V223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_775",
    className: "st16",
    d: "M314.4,223.8l18.9-10.9v8.7l-18.9,10.9V223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_776",
    className: "st6",
    d: "M314.4,241.3l18.9-10.9v8.7L314.4,250V241.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_777",
    className: "st10",
    d: "M143.9,251.8l-0.2,0.1v123.5l227.8-131.6l0.2-0.1V120.2L143.9,251.8z M370.8,234.5 l-18,10.4v-7.7l18-10.4V234.5z M144.5,261.2l18-10.4v7.7l-18,10.4V261.2z M257.2,248.6v7.7l-18,10.4V259L257.2,248.6z  M239.2,258v-7.7l18-10.4v7.7L239.2,258z M258.1,248.1l18-10.4v7.7l-18,10.4V248.1z M258.1,247v-7.7l18-10.4v7.7L258.1,247z  M258.1,238.3v-7.6l18-10.4v7.7L258.1,238.3z M258.1,229.5v-7.7l18-10.4v7.7L258.1,229.5z M257.2,230.1l-18,10.4v-7.7l18-10.4 V230.1z M257.2,231.2v7.7l-18,10.4v-7.7L257.2,231.2z M238.3,249.8l-18,10.4v-7.7l18-10.4V249.8z M238.3,250.8v7.7l-18,10.4 v-7.7L238.3,250.8z M238.3,259.6v7.7l-18,10.4V270L238.3,259.6z M238.3,268.3v7.7l-18,10.4v-7.7L238.3,268.3z M239.2,267.8 l18-10.4v7.7l-18,10.4V267.8z M257.2,266.1v7.7l-18,10.4v-7.7L257.2,266.1z M258.1,265.6l18-10.4v7.7l-18,10.4V265.6z  M258.1,264.5v-7.7l18-10.4v7.7L258.1,264.5z M277,245.9l18-10.4v7.7l-18,10.4V245.9z M277,244.8v-7.7l18-10.4v7.7L277,244.8z  M277,236.1v-7.7l18-10.4v7.7L277,236.1z M277,227.4v-7.7l18-10.4v7.7L277,227.4z M277,218.6v-7.7l18-10.4v7.7L277,218.6z  M277,209.9v-7.7l18-10.4v7.7L277,209.9z M276.1,210.4l-18,10.4v-7.7l18-10.4V210.4z M257.2,221.3l-18,10.4v-7.7l18-10.4V221.3z  M238.3,232.3l-18,10.4V235l18-10.4V232.3z M238.3,233.3v7.7l-18,10.4v-7.7L238.3,233.3z M219.3,251.9l-18,10.4v-7.7l18-10.4 V251.9z M219.3,253v7.6l-18,10.4v-7.7L219.3,253z M219.3,261.8v7.7l-18,10.4v-7.7L219.3,261.8z M219.3,270.5v7.7l-18,10.4v-7.7 L219.3,270.5z M219.3,279.2v7.7l-18,10.4v-7.7L219.3,279.2z M219.3,288v7.6l-18,10.4v-7.7L219.3,288z M220.3,287.5l18-10.4v7.7 l-18,10.4V287.5z M238.3,285.8v7.7l-18,10.4v-7.7L238.3,285.8z M239.2,285.3l18-10.4v7.7l-18,10.4V285.3z M258.1,274.3l18-10.4 v7.7l-18,10.4V274.3z M277,263.4l18-10.4v7.7l-18,10.4V263.4z M277,262.3v-7.7l18-10.4v7.7L277,262.3z M296,243.7l18-10.4v7.7 l-18,10.4V243.7z M296,242.7V235l18-10.4v7.7L296,242.7z M296,233.9v-7.7l18-10.4v7.7L296,233.9z M296,225.2v-7.7l18-10.4v7.7 L296,225.2z M296,216.4v-7.7l18-10.4v7.7L296,216.4z M296,207.7V200l18-10.4v7.7L296,207.7z M296,198.9v-7.7l18-10.4v7.7 L296,198.9z M296,190.2v-7.7l18-10.4v7.7L296,190.2z M295,190.7l-18,10.4v-7.7l18-10.4V190.7z M276.1,201.6l-18,10.4v-7.7 l18-10.4V201.6z M257.2,212.6l-18,10.4v-7.7l18-10.4V212.6z M238.3,223.5l-18,10.4v-7.7l18-10.4V223.5z M219.3,234.4l-18,10.4 v-7.7l18-10.4V234.4z M219.3,235.5v7.7l-18,10.4v-7.7L219.3,235.5z M200.4,254.1l-18,10.4v-7.7l18-10.4V254.1z M200.4,255.2v7.7 l-18,10.4v-7.7L200.4,255.2z M200.4,263.9v7.7l-18,10.4v-7.7L200.4,263.9z M200.4,272.7v7.7l-18,10.4v-7.7L200.4,272.7z  M200.4,281.4v7.7l-18,10.4v-7.7L200.4,281.4z M200.4,290.2v7.7l-18,10.4v-7.7L200.4,290.2z M200.4,298.9v7.7l-18,10.4v-7.7 L200.4,298.9z M200.4,307.7v7.7l-18,10.4v-7.7L200.4,307.7z M201.3,307.1l18-10.4v7.7l-18,10.4V307.1z M219.3,305.5v7.7 l-18,10.4v-7.7L219.3,305.5z M220.2,304.9l18-10.4v7.7l-18,10.4V304.9z M239.2,294l18-10.4v7.7l-18,10.4V294z M258.1,283.1 l18-10.4v7.7l-18,10.4V283.1z M277,272.2l18-10.4v7.7l-18,10.4V272.2z M296,261.2l18-10.4v7.7l-18,10.4V261.2z M296,260.2v-7.7 l18-10.4v7.7L296,260.2z M314.9,241.6l18-10.4v7.7l-18,10.4V241.6z M314.9,240.5v-7.7l18-10.4v7.7L314.9,240.5z M314.9,231.7 v-7.7l18-10.4v7.7L314.9,231.7z M314.9,223v-7.7l18-10.4v7.7L314.9,223z M314.9,214.2v-7.7l18-10.4v7.7L314.9,214.2z  M314.9,205.5v-7.7l18-10.4v7.7L314.9,205.5z M314.9,196.8v-7.7l18-10.4v7.7L314.9,196.8z M314.9,188v-7.7l18-10.4v7.7 L314.9,188z M314.9,179.3v-7.6l18-10.4v7.7L314.9,179.3z M314.9,170.5v-7.7l18-10.4v7.7L314.9,170.5z M313.9,171.1l-18,10.4 v-7.7l18-10.4V171.1z M295,182l-18,10.4v-7.7l18-10.4V182z M276.1,192.9l-18,10.4v-7.7l18-10.4V192.9z M257.2,203.8l-18,10.4 v-7.7l18-10.4V203.8z M238.3,214.8l-18,10.4v-7.7l18-10.4V214.8z M219.3,225.7l-18,10.4v-7.7l18-10.4V225.7z M200.4,236.6 l-18,10.4v-7.7l18-10.4V236.6z M200.4,237.7v7.7l-18,10.4v-7.7L200.4,237.7z M181.5,256.3l-18,10.4V259l18-10.4V256.3z  M181.5,257.4v7.7l-18,10.4v-7.7L181.5,257.4z M181.5,266.1v7.7l-18,10.4v-7.7L181.5,266.1z M181.5,274.9v7.7l-18,10.4v-7.7 L181.5,274.9z M181.5,283.6v7.7l-18,10.3V294L181.5,283.6z M181.5,292.4v7.7l-18,10.4v-7.7L181.5,292.4z M181.5,301.1v7.7 l-18,10.4v-7.7L181.5,301.1z M181.5,309.9v7.7l-18,10.4v-7.7L181.5,309.9z M181.5,318.6v7.7l-18,10.4V329L181.5,318.6z  M181.5,327.4v7.7l-18,10.4v-7.7L181.5,327.4z M182.4,326.8l18-10.4v7.7l-18,10.4V326.8z M200.4,325.2v7.7l-18,10.4v-7.7 L200.4,325.2z M201.3,324.6l18-10.4v7.7l-18,10.4V324.6z M220.2,313.6l18-10.4v7.7l-18,10.4V313.6z M239.2,302.7l18-10.4v7.7 l-18,10.4V302.7z M258.1,291.8l18-10.4v7.7l-18,10.4V291.8z M277,280.9l18-10.4v7.7l-18,10.4V280.9z M296,269.9l18-10.4v7.7 l-18,10.4V269.9z M314.9,259l18-10.4v7.7l-18,10.4V259z M314.9,258v-7.7l18-10.4v7.7L314.9,258z M333.9,239.4l18-10.4v7.7 l-18,10.4V239.4z M333.9,238.3v-7.6l18-10.4v7.7L333.9,238.3z M333.9,229.5v-7.7l18-10.4v7.7L333.9,229.5z M333.9,220.8v-7.7 l18-10.4v7.7L333.9,220.8z M333.9,212.1v-7.7l18-10.4v7.7L333.9,212.1z M333.9,203.3v-7.7l18-10.4v7.7L333.9,203.3z  M333.9,194.6v-7.7l18-10.4v7.7L333.9,194.6z M333.9,185.8v-7.7l18-10.4v7.7L333.9,185.8z M333.9,177.1v-7.7l18-10.4v7.6 L333.9,177.1z M333.9,168.3v-7.7l18-10.4v7.7L333.9,168.3z M333.9,159.6v-7.7l18-10.4v7.7L333.9,159.6z M333.9,150.8v-7.7 l18-10.4v7.7L333.9,150.8z M332.9,151.4l-18,10.4v-7.7l18-10.4V151.4z M314,162.3l-18,10.4V165l18-10.4V162.3z M295.1,173.2 l-18,10.4V176l18-10.4V173.2z M276.1,184.2l-18,10.4v-7.7l18-10.4V184.2z M257.2,195.1l-18,10.4v-7.7l18-10.4V195.1z M238.3,206 l-18,10.4v-7.7l18-10.4V206z M219.4,217l-18,10.4v-7.7l18-10.4V217z M200.4,227.9l-18,10.4v-7.6l18-10.4V227.9z M181.5,238.8 l-18,10.4v-7.7l18-10.4V238.8z M181.5,239.9v7.7l-18,10.4v-7.7L181.5,239.9z M144.5,270l18-10.4v7.7l-18,10.4V270z M144.5,278.7 l18-10.4v7.7l-18,10.4V278.7z M144.5,287.4l18-10.4v7.7l-18,10.4V287.4z M144.5,296.2l18-10.4v7.7l-18,10.4V296.2z M144.5,304.9 l18-10.4v7.7l-18,10.4V304.9z M144.5,313.7l18-10.4v7.7l-18,10.4V313.7z M144.5,322.4l18-10.4v7.7l-18,10.4V322.4z M144.5,331.2 l18-10.4v7.7l-18,10.4V331.2z M144.5,339.9l18-10.4v7.7l-18,10.4V339.9z M144.5,348.7l18-10.4v7.7l-18,10.4V348.7z M144.5,357.4 l18-10.4v7.6l-18,10.4V357.4z M163.5,346.5l18-10.4v7.7l-18,10.4V346.5z M181.5,344.8v7.6l-18,10.4v-7.6L181.5,344.8z  M182.4,344.3l18-10.4v7.6l-18,10.4V344.3z M201.3,333.4l18-10.4v7.7l-18,10.4V333.4z M220.2,322.4l18-10.4v7.6l-18,10.4V322.4z  M239.2,311.5l18-10.4v7.6l-18,10.4V311.5z M258.1,300.6l18-10.4v7.6l-18,10.4V300.6z M277,289.6l18-10.4v7.6l-18,10.4V289.6z  M296,278.7l18-10.4v7.6l-18,10.4V278.7z M314.9,267.8l18-10.4v7.6l-18,10.4V267.8z M333.9,256.9l18-10.4v7.6l-18,10.4V256.9z  M333.9,255.8v-7.7l18-10.4v7.7L333.9,255.8z M370.8,225.7l-18,10.4v-7.7l18-10.4V225.7z M370.8,217l-18,10.4v-7.7l18-10.4V217z  M370.8,208.2l-18,10.4V211l18-10.4L370.8,208.2z M370.8,199.5l-18,10.4v-7.7l18-10.4V199.5z M370.8,190.7l-18,10.4v-7.7 l18-10.4V190.7z M370.8,182l-18,10.4v-7.7l18-10.4V182z M370.8,173.3l-18,10.4V176l18-10.4L370.8,173.3z M370.8,164.5l-18,10.4 v-7.7l18-10.4V164.5z M370.8,155.8l-18,10.4v-7.7l18-10.4V155.8z M370.8,147l-18,10.4v-7.7l18-10.4V147z M370.8,138.3l-18,10.4 V141l18-10.4L370.8,138.3z M370.8,129.5l-18,10.4v-7.7l18-10.4V129.5z M162.5,242.1v7.7l-18,10.4v-7.7L162.5,242.1z  M144.5,366.1l18-10.4v7.6l-18,10.4V366.1z M352.8,253.6v-7.6l18-10.4v7.6L352.8,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_778",
    className: "st9",
    d: "M295.5,173.5l75.8-43.7v43.7l-75.8,43.7V173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_779",
    className: "st10",
    d: "M295,218.1v-44.9l0.2-0.1l76.5-44.1v44.9L295,218.1z M296,173.8v42.6l74.8-43.1v-42.6 L296,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_780",
    className: "st5",
    d: "M299.3,206.6h-0.1c-0.2-0.1-0.3-0.3-0.2-0.5l10.2-28c0.1-0.2,0.3-0.3,0.5-0.2c0,0,0,0,0,0 l11.1,6.7l11.2-11.4c0.1-0.1,0.3-0.1,0.5,0l11,7.2l11.2-27.5c0.1-0.2,0.3-0.3,0.5-0.2c0,0,0,0,0,0l11.4,5.8 c0.2,0.1,0.3,0.3,0.2,0.5c-0.1,0.2-0.3,0.3-0.5,0.2l0,0l-11-5.6l-11.2,27.6c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.3,0l-11.1-7.3 l-11.2,11.4c-0.1,0.1-0.3,0.1-0.5,0.1l-10.9-6.5l-10.1,27.5C299.6,206.6,299.4,206.7,299.3,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_781",
    className: "st6",
    d: "M309.5,177c-0.7,0.4-1.1,1.2-1.1,2c0,0.7,0.5,1,1.1,0.7c0.7-0.4,1.1-1.2,1.1-2 C310.7,177,310.2,176.6,309.5,177z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    className: "st6",
    d: "M320.9,183.8c-0.7,0.4-1.1,1.2-1.1,2c0,0.7,0.5,1,1.1,0.7c0.7-0.4,1.1-1.2,1.1-2 C322,183.7,321.5,183.4,320.9,183.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    className: "st6",
    d: "M332.2,172.2c-0.7,0.4-1.1,1.2-1.1,2c0,0.7,0.5,1,1.1,0.7c0.7-0.4,1.1-1.2,1.1-2 C333.4,172.1,332.9,171.8,332.2,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_784",
    className: "st6",
    d: "M343.6,179.6c-0.7,0.4-1.1,1.2-1.1,2c0,0.7,0.5,1,1.1,0.7c0.7-0.4,1.1-1.2,1.1-2 c0.1-0.4-0.2-0.7-0.6-0.8C343.9,179.5,343.7,179.5,343.6,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_785",
    className: "st6",
    d: "M354.9,151.7c-0.7,0.4-1.1,1.2-1.1,2c0,0.7,0.5,1,1.1,0.7c0.7-0.4,1.1-1.2,1.1-2 C356.1,151.6,355.6,151.4,354.9,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_786",
    className: "st6",
    d: "M366.3,157.6c-0.7,0.4-1.1,1.2-1.1,2c0,0.7,0.5,1,1.1,0.7c0.7-0.4,1.1-1.2,1.1-2 C367.4,157.5,366.9,157.2,366.3,157.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts--inject-90-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    className: "st5",
    d: "M402.7,290.8l-20.1,11.6l20.1,11.6l20.1-11.6L402.7,290.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    className: "st4",
    d: "M422.9,302.4v46.2l-20.1,11.6v-46.2L422.9,302.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_789",
    className: "st3",
    d: "M402.7,314.1v46.2l-20.1-11.6v-46.2L402.7,314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    className: "st6",
    d: "M376.2,326.2l-20.1,11.6l20.1,11.6l20.1-11.6L376.2,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    className: "st20",
    d: "M376.2,326.2l-20.1,11.6l20.1,11.6l20.1-11.6L376.2,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    className: "st6",
    d: "M396.4,337.8V364l-20.1,11.6v-26.2L396.4,337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    className: "st6",
    d: "M376.2,349.5v26.2L356.1,364v-26.2L376.2,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    className: "st21",
    d: "M376.2,349.5v26.2L356.1,364v-26.2L376.2,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_795",
    className: "st6",
    d: "M349.7,330.6l-20.1,11.6l20.1,11.6l20.1-11.6L349.7,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_796",
    className: "st22",
    d: "M349.7,330.6l-20.1,11.6l20.1,11.6l20.1-11.6L349.7,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_797",
    className: "st6",
    d: "M369.9,342.2v37.1l-20.1,11.6v-37L369.9,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_798",
    className: "st23",
    d: "M369.9,342.2v37.1l-20.1,11.6v-37L369.9,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_799",
    className: "st6",
    d: "M349.7,353.9v37l-20.1-11.6v-37.1L349.7,353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    className: "st19",
    d: "M349.7,353.9v37l-20.1-11.6v-37.1L349.7,353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    className: "st6",
    d: "M323.2,369.9l-20.1,11.6l20.1,11.6l20.1-11.6L323.2,369.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    className: "st8",
    d: "M323.2,369.9l-20.1,11.6l20.1,11.6l20.1-11.6L323.2,369.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    className: "st6",
    d: "M343.4,381.5v13.1l-20.1,11.6v-13.1L343.4,381.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_804",
    className: "st17",
    d: "M343.4,381.5v13.1l-20.1,11.6v-13.1L343.4,381.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_805",
    className: "st6",
    d: "M323.2,393.2v13.1l-20.1-11.6v-13.1L323.2,393.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_806",
    className: "st24",
    d: "M323.2,393.2v13.1l-20.1-11.6v-13.1L323.2,393.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts--inject-90-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_807",
    className: "st3",
    d: "M213.5,451.2v7.6l-7.5-20.5v-7.6l0,0L213.5,451.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_808",
    className: "st4",
    d: "M213.5,451.3v7.6l31.1-10.8v-7.6L213.5,451.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_809",
    className: "st5",
    d: "M206,430.8l7.5,20.5l31.1-10.8C236.1,433,221.2,429.3,206,430.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_810",
    className: "st6",
    d: "M173.5,452.6c0,0.1,0,0.2,0,0.2V452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_811",
    className: "st6",
    d: "M210.4,460.9l-4.6,21.7c-18.8-1.8-32.4-11.4-32.3-22.2v-7.4c0,10.8,13.6,20.2,32.3,22 L209,460L210.4,460.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_812",
    className: "st17",
    d: "M210.4,460.9l-4.6,21.7c-18.8-1.8-32.4-11.4-32.3-22.2v-7.4c0,10.8,13.6,20.2,32.3,22 L209,460L210.4,460.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_813",
    className: "st6",
    d: "M209.3,475.2v7.6c7.8,0.4,15.6-0.6,22.9-3.2c8.9-3.1,15.1-8,17.7-13.8 c0.7-1.7,1.1-3.5,1.2-5.3v-7.9c0,0-2.1-0.2-4.7-2.9l-5.8,2l-26.6,9.2L209.3,475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    className: "st19",
    d: "M209.3,475.2v7.6c7.8,0.4,15.6-0.6,22.9-3.2c8.9-3.1,15.1-8,17.7-13.8 c0.7-1.7,1.1-3.5,1.2-5.3v-7.9c0,0-2.1-0.2-4.7-2.9l-5.8,2l-26.6,9.2L209.3,475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    className: "st6",
    d: "M186.2,444l23.1,13.4v-7.6l-23.1-13.4V444z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    className: "st21",
    d: "M186.2,444l23.1,13.4v-7.6l-23.1-13.4V444z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    className: "st6",
    d: "M173.9,450.1c-2.5,11.9,11.7,22.8,32,24.8l4.6-21.7l-26.8-15.5 C178.1,441.3,174.9,445.3,173.9,450.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    className: "st8",
    d: "M173.9,450.1c-2.5,11.9,11.7,22.8,32,24.8l4.6-21.7l-26.8-15.5 C178.1,441.3,174.9,445.3,173.9,450.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    className: "st6",
    d: "M209.5,474.6l-0.1,0.6c7.8,0.5,15.6-0.6,22.9-3.1c8.9-3.1,15.1-8,17.7-13.8 c2.4-5.5,1.1-11.1-3.5-16l-5.8,2l-26.6,9.2L209.5,474.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_820",
    className: "st23",
    d: "M209.5,474.6l-0.1,0.6c7.8,0.5,15.6-0.6,22.9-3.1c8.9-3.1,15.1-8,17.7-13.8 c2.4-5.5,1.1-11.1-3.5-16l-5.8,2l-26.6,9.2L209.5,474.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_821",
    className: "st6",
    d: "M186.2,436.3l23.1,13.4l-6.8-18.5C196.8,431.9,191.3,433.6,186.2,436.3L186.2,436.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_822",
    className: "st6",
    d: "M210.4,460.9v-7.6l-4.6,21.7v7.6L210.4,460.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_823",
    className: "st24",
    d: "M210.4,460.9v-7.6l-4.6,21.7v7.6L210.4,460.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_824",
    className: "st6",
    d: "M239.9,419.4l-5,2.9l5,2.9l5-2.9L239.9,419.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_825",
    className: "st8",
    d: "M239.9,419.4l-5,2.9l5,2.9l5-2.9L239.9,419.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_826",
    className: "st6",
    d: "M245,422.3v2.9l-5,2.9v-2.9L245,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_827",
    className: "st17",
    d: "M245,422.3v2.9l-5,2.9v-2.9L245,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_828",
    className: "st6",
    d: "M239.9,425.2v2.9l-5-2.9v-2.9L239.9,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_829",
    className: "st24",
    d: "M239.9,425.2v2.9l-5-2.9v-2.9L239.9,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_830",
    className: "st10",
    d: "M247.6,417.1l18.7-10.8c1.2-0.6,2.7-0.7,3.9-0.1c1,0.6,1,1.6-0.1,2.3l-18.7,10.8 c-1.2,0.6-2.7,0.7-3.9,0.1C246.5,418.8,246.5,417.7,247.6,417.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_831",
    className: "st6",
    d: "M251.3,425.9l-5,2.9l5,2.9l5-2.9L251.3,425.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_832",
    className: "st22",
    d: "M251.3,425.9l-5,2.9l5,2.9l5-2.9L251.3,425.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_833",
    className: "st6",
    d: "M256.3,428.8v2.9l-5,2.9v-2.9L256.3,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_834",
    className: "st23",
    d: "M256.3,428.8v2.9l-5,2.9v-2.9L256.3,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_835",
    className: "st6",
    d: "M251.3,431.7v2.9l-5-2.9v-2.9L251.3,431.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_836",
    className: "st19",
    d: "M251.3,431.7v2.9l-5-2.9v-2.9L251.3,431.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    className: "st10",
    d: "M259,423.6l18.7-10.8c1.2-0.6,2.7-0.7,3.9-0.1c1,0.6,1,1.6-0.1,2.3l-18.7,10.8 c-1.2,0.6-2.7,0.7-3.9,0.1C257.9,425.3,257.9,424.3,259,423.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    className: "st6",
    d: "M262.6,432.5l-5,2.9l5,2.9l5-2.9L262.6,432.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    className: "st20",
    d: "M262.6,432.5l-5,2.9l5,2.9l5-2.9L262.6,432.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    className: "st6",
    d: "M267.7,435.4v2.9l-5,2.9v-2.9L267.7,435.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_841",
    className: "st6",
    d: "M262.7,438.3v2.9l-5-2.9v-2.9L262.7,438.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_842",
    className: "st21",
    d: "M262.7,438.3v2.9l-5-2.9v-2.9L262.7,438.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_843",
    className: "st10",
    d: "M270.4,430.2l18.7-10.8c1.2-0.6,2.7-0.7,3.9-0.1c1,0.6,1,1.6-0.1,2.3l-18.7,10.8 c-1.2,0.6-2.7,0.7-3.9,0.1C269.2,431.9,269.2,430.9,270.4,430.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_844",
    className: "st5",
    d: "M274,439l-5,2.9l5,2.9l5-2.9L274,439z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_845",
    className: "st4",
    d: "M279.1,441.9v2.9l-5,2.9v-2.9L279.1,441.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_846",
    className: "st3",
    d: "M274,444.8v2.9l-5-2.9v-2.9L274,444.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_847",
    className: "st10",
    d: "M281.7,436.8l18.7-10.8c1.2-0.6,2.7-0.7,3.9-0.1c1,0.6,1,1.6-0.1,2.3L285.5,439 c-1.2,0.6-2.7,0.7-3.9,0.1C280.5,438.4,280.6,437.4,281.7,436.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-90-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_848",
    className: "st25",
    d: "M432.1,281.1c6.9,0,10.2,2,12.7,8.6c2.5,6.6,9.1,21.9,9.2,26.4c0.1,4.7-15,18.9-14.4,18.7 c0.2-0.1-4.6-8.6-4.6-8.6l8.5-10.4l-4.9-14.1L432.1,281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_849",
    className: "st3",
    d: "M440.7,436.5c0.4,0.4,0.5,0.8,0.5,2.3s0.6,3.1-0.1,4.5c-0.6,1-3.5,1.7-4.9,1 c-1.3-0.8-2.4-1.9-3.4-3c-0.9-1-1.9-2-3-2.9c-1.2-0.9-2.7-1.5-4-2.4c-2.1-1.3-3.4-3.5-3.6-6c-0.1-0.8,0.1-1.6,0.5-2.3 c0.6-0.8,1.6-1.1,2.6-0.9c1.4,0.2,6.2,2.9,7.3,3.7C433.9,431.4,440.2,436.1,440.7,436.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_850",
    className: "st25",
    d: "M433.7,430.4c0,1.1-4.5-1.4-6.4-1.2h0c-1.7,0.8-0.3,3.2,1.3,4.4s6.8,5,6.8,5l1.1-6.1 L433.7,430.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_851",
    className: "st3",
    d: "M414.3,447.6c0.8,0,1.2,2.7,1.4,4.8c0.1,1.6,0.7,4.3,0.1,5.5s-2.8,1.9-6.1,1.9 c-2.2,0-5.6,1.4-8,2.7c-2.4,1.1-5,1.5-7.6,1c-3-0.4-6.1-2.2-6.5-3.4s0.2-1.8,7.3-4.8c0.1,0,7.5-3.3,11-7L414.3,447.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_852",
    className: "st25",
    d: "M394.9,455.2c-1,0.4-1.8,0.8-2.6,1.1c-0.2,0.7,0.1,1.7,3.2,2.3c4.8,0.8,18.8-9.8,18.8-9.8 s-2,0.6-2.4-0.6h-6.1C402.3,451.9,394.9,455.2,394.9,455.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_853",
    className: "st25",
    d: "M443.5,401.7c0.1-4.7-0.4-9.3-1.4-13.9c0,0,0.8-17.9,0.9-29.1c0.2-22.2-0.2-25.5-5.1-35 c0,0-28.7-3.4-29.9,10.6c-1.5,17.4-3.2,46.5-3.2,54.8c0,6.2,0.7,12.9,1.1,26.9c0.2,9,1.2,21.6-0.1,32.2c1.6,2.7,6,2.7,8.5,0.5 c0.7-10.4,5.9-30.3,6.7-37.2c0.4-5,0.2-10-0.6-15c0,0,3.8-29.6,4.5-34.1c1,4.8,1.5,9.6,1.7,14.5c0,2,0.7,8.6,1.8,19.7 c0.7,6.8,5.5,33.2,6.5,41.7c2.4,2.3,5.5,0.7,5.6-0.3C441.3,427.6,443.5,408.2,443.5,401.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_854",
    className: "st14",
    d: "M424.9,362.4l2.5-14.4c4.3-0.7,8.3-2.7,11.3-5.9c0,0-1.5,5.8-9,7.7l-3,13l-0.5,11.9 L424.9,362.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_855",
    className: "st25",
    d: "M417.6,276.3l1.2,13l11.5-0.7l-0.9-14.5L417.6,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_856",
    className: "st6",
    d: "M440.6,327.2c-1.3-3.5-3-6.8-5-9.9c4.9-15.8,6.5-21.1,5.5-27.8c-0.6-4.3-4-8.6-8.2-8.4 h-3.1c-0.2,3-8.5,3.1-11.6,1.1l-2.9,0.1c-2,0.7-9,11-9.8,17.8c-0.6,5.5,3.7,10.3,3.7,10.3c0,2.3-0.1,4.7-0.4,7v20 c0,0,1.6,5.1,18.4,3.5c15-1.4,15.3-6.5,15.3-6.5C442.2,331.9,441.6,329.5,440.6,327.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_857",
    d: "M440.6,327.2c-1.3-3.5-3-6.8-5-9.9c4.9-15.8,6.5-21.1,5.5-27.8c-0.6-4.3-4-8.6-8.2-8.4h-3.1 c-0.2,3-8.5,3.1-11.6,1.1l-2.9,0.1c-2,0.7-9,11-9.8,17.8c-0.6,5.5,3.7,10.3,3.7,10.3c0,2.3-0.1,4.7-0.4,7v20 c0,0,1.6,5.1,18.4,3.5c15-1.4,15.3-6.5,15.3-6.5C442.2,331.9,441.6,329.5,440.6,327.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_858",
    className: "st3",
    d: "M419.4,245.8c-3.4-0.5-6.9,0.8-9.2,3.3c-5.9,6.6,0.6,11.5,0.6,11.5L419.4,245.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_859",
    className: "st27",
    d: "M409.2,262c0,0-2.5,3.8-2.2,4.2c0.6,0.4,1.2,0.7,1.9,0.8L409.2,262z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_860",
    className: "st25",
    d: "M417,249.8c-2.5,1.3-6.7,3.6-7.9,12.7c-1.1,9.3,0.9,12.6,2.2,13.8 c0.9,0.8,5.3,1.1,7.6,0.4c2.9-0.9,9.2-4,12.1-8.8c3.5-5.6,4.2-13.2,0.2-16.2C425.6,247.6,419.1,248.8,417,249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_861",
    className: "st3",
    d: "M415.7,260.6c-5.2-2.6-3.9-9.5-3.9-9.5s7.4-10.6,21-3.7c4.7,2.4,7.5,7.7,7.4,14l0,0 c0,8.2-6.6,14.8-14.8,14.8l0,0c-4.8,0-8.6-3.9-8.6-8.6v-0.6l0.4,0.1c1.4,0.3,2.9-0.1,4-1.1c2.3-2,2.5-5.8-0.3-6.8 c-2.9-1-4.4,2.4-4.4,2.4l0,0l-1.1,3c-1.1-0.4-1.7-1.7-1.3-2.8c0,0,0,0,0,0C414.5,261.2,415.1,260.7,415.7,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_862",
    className: "st6",
    d: "M384.5,262.7L359.9,275l11.6,33.3l23-12.4L384.5,262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_863",
    className: "st15",
    d: "M383.3,265.9l-20.6,10.3l10.2,28.6l19.3-10.4L383.3,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_864",
    className: "st14",
    d: "M379,268.9l-0.4-1c-0.2-0.6-1.9-0.2-3.8,0.7l-3.6,1.8c-1.9,0.9-3.3,2.2-3,2.7l0.4,1 L379,268.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_865",
    className: "st4",
    d: "M378.6,264.8c-0.1-0.4-0.9-0.3-1.7,0.1l-1.4,0.7c0,0-0.8-2.2-4.1-0.7s-2.6,4-2.6,4 l-1.5,0.8c-0.8,0.4-1.4,1.1-1.3,1.4l0.2,0.6l12.7-6.3L378.6,264.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_866",
    className: "st3",
    d: "M377.2,266.3c-1.2,0.6-1.6,0.8-1.3,1.7s0.7,1.7,0.7,1.7l-5.6,2.8c0,0-0.4-1.3-0.6-1.7 s-0.6-0.7-1.5-0.3l-0.3-0.4l8.8-4.3L377.2,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_867",
    className: "st4",
    d: "M379.2,268.9l-0.4-1c-0.2-0.6-1.9-0.3-3.8,0.7l-3.6,1.8c-1.9,0.9-3.3,2.2-3,2.7l0.4,1 L379.2,268.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_868",
    className: "st25",
    d: "M415.3,282.3c-3.9-0.1-6.2,0.3-11.5,8.1s-15.1,22.2-16.2,24.2c-1.6,2.6-2,6.6-0.7,9 c1.2,2.3,3.4,3.1,9.4-3.4c4.5-4.8,14-17.5,14-17.5S417.7,288.9,415.3,282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_869",
    className: "st25",
    d: "M389.3,325.2c-3.2,1-14.9-12.9-18.1-17.1c-2.6-3.5-5.7-6.6-9.1-9.3 c-4.5-3.5-3.8-8.6-1.7-13.3c0.7-1.6,3-0.5,3-0.5l0.8,2.3l1.4,3.9c1,0.9,1.5,1.2,1.6,0.9c0.1-0.5-0.7-2.6-0.6-4.8 c0.1-2.6,1.9-0.9,2.4,0.1c0.7,1.4,1.4,2.9,1.9,4.4c0.9,2.4,0.5,4.7,1.6,6.4c1.1,1.6,17,14.8,17,14.8L389.3,325.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_870",
    className: "st6",
    d: "M435.7,317.3c0,0-11.2,6.6-26.9,0c-1.4,8.2-2.4,16.5-2.9,24.9c-0.6,10.6-1.8,33.4-1.8,33.4 s4.6,5.4,21.2,4.3c15.9-1,18.7-5.2,18.7-5.2s0-20.5,0.1-29.4C444.2,333.9,442.6,327.6,435.7,317.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_871",
    className: "st18",
    d: "M435.7,317.3c0,0-11.2,6.6-26.9,0c-1.4,8.2-2.4,16.5-2.9,24.9 c-0.6,10.6-1.8,33.4-1.8,33.4s4.6,5.4,21.2,4.3c15.9-1,18.7-5.2,18.7-5.2s0-20.5,0.1-29.4C444.2,333.9,442.6,327.6,435.7,317.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_872",
    className: "st3",
    d: "M440.9,256.9l2.6-2.4c-0.9-0.9-2.3-1-3.3-0.1c-0.6,0.6-0.9,1.5-0.6,2.3c-0.3,0-0.6,0-1,0 v21.1c0,6.1,4.9,11,11,11v-21.1C449.5,262.5,445.9,258,440.9,256.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisando);
export default __webpack_public_path__ + "static/media/Analisando.216f6afc4c5b397d5e1a4d0236743f1c.svg";
export { ForwardRef as ReactComponent };